import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAutomationCreateRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation-create',
	path: '/jira/servicedesk/projects/:projectKey/settings/automation/blueprint/:blueprintKey',
};
